const API_ENDPOINTS = {
  auth: {
    login: "/login",
    loginPanel: "/loginpanel",
    superAdminLogin: "/super-admin-login",
    whatsappLogin: "/auth/whatsapp/login",
    register: "/register",
    googleLogin: "/google-login",
    appleLogin: "/apple-login",
    forgotPasswordSend: "/forgot-password/send-code",
    forgotPasswordReset: "/forgot-password/reset",
  },
  /* Misafir oturumu: start giriş yapmadan geçici hesap açar,
     claim ise o hesabı kalıcıya çevirir (veri aynı tenantta kalır). */
  guest: {
    start: "/api/guest/start",
    claim: "/api/guest/claim",
  },
  botSettings: {
    list: "/api/bot-settings/list",
    create: "/api/bot-settings/create",
    update: "/api/bot-settings/update",
  },
  users: {
    list: "/api/users/panel/users",
    create: "/api/users/panel/users/create",
    update: "/api/users/panel/users/update",
    delete: "/api/users/panel/users/delete",
    loginAs: "/api/users/admin/login-as",
    /* Oturum sahibinin kendi hesabını silmesi (mobil uygulamada zorunlu) */
    deleteAccount: "/api/users/delete-account",
  },
  tenantMembers: {
    list: "/api/tenant-members/list",
    getById: "/api/tenant-members/getById",
    create: "/api/tenant-members/create",
    update: "/api/tenant-members/update",
    delete: "/api/tenant-members/delete",
  },
  campaigns: {
    list: "/api/campaigns/list",
    create: "/api/campaigns/create",
    update: "/api/campaigns/update",
    delete: "/api/campaigns/delete",
    launch: "/api/campaigns/launch",
    stats: "/api/campaigns/stats",
  },
  gamification: {
    achievements: "/api/gamification/achievements",
    progress: "/api/gamification/progress",
    check: "/api/gamification/check",
  },
  zapier: {
    webhooks: "/api/zapier/webhooks",
    triggers: "/api/zapier/triggers",
    actions: "/api/zapier/actions",
    createWebhook: "/api/zapier/webhooks/create",
    deleteWebhook: "/api/zapier/webhooks/delete",
  },
  crm: {
    connections: "/api/crm/connections",
    createConnection: "/api/crm/connections/create",
    sync: "/api/crm/sync",
    deleteConnection: "/api/crm/connections/delete",
  },
  ecommerce: {
    connections: "/api/ecommerce/connections",
    createConnection: "/api/ecommerce/connections/create",
    testConnection: "/api/ecommerce/connections/test",
    syncOrders: "/api/ecommerce/sync-orders",
    syncProducts: "/api/ecommerce/sync-products",
    registerWebhooks: "/api/ecommerce/register-webhooks",
    deleteConnection: "/api/ecommerce/connections/delete",
  },
  lifecycle: {
    pipeline: "/api/lifecycle/pipeline",
    history: "/api/lifecycle/history",
  },
  onboarding: {
    status: "/api/onboarding/status",
    sectors: "/api/onboarding/sectors",
    completeStep: "/api/onboarding/complete-step",
    initializeSector: "/api/onboarding/initialize-sector",
    quickActivate: "/api/onboarding/quick-activate",
    activationState: "/api/onboarding/activation-state",
    skip: "/api/onboarding/skip",
  },
  productEvents: {
    track: "/api/product-events",
  },
  messageTemplates: {
    list: "/api/message-templates/list",
    create: "/api/message-templates/create",
    createRecommended: "/api/message-templates/create-recommended",
    update: "/api/message-templates/update",
    submit: "/api/message-templates/submit",
    syncStatus: "/api/message-templates/sync-status",
    languages: "/api/message-templates/languages",
    testSend: "/api/message-templates/test-send",
    delete: "/api/message-templates/delete",
  },
  whatsappAccounts: {
    list: "/api/whatsapp-accounts/list",
    health: "/api/whatsapp-accounts/health",
    create: "/api/whatsapp-accounts/create",
    update: "/api/whatsapp-accounts/update",
    delete: "/api/whatsapp-accounts/delete",
    manualInfo: "/api/whatsapp-accounts/manual-info",
    manualConnect: "/api/whatsapp-accounts/manual-connect",
  },
  instagramAccounts: {
    list: "/api/instagram-accounts/list",
    manualInfo: "/api/instagram-accounts/manual-info",
    manualConnect: "/api/instagram-accounts/manual-connect",
  },
  telegramSetup: {
    status: "/api/telegram-setup/status",
    saveToken: "/api/telegram-setup/save-token",
    setWebhook: "/api/telegram-setup/set-webhook",
    removeWebhook: "/api/telegram-setup/remove-webhook",
    testMessage: "/api/telegram-setup/test-message",
  },
  channelSetup: {
    tiktokStatus: "/api/channel-setup/tiktok/status",
    tiktokSaveToken: "/api/channel-setup/tiktok/save-token",
    tiktokSetWebhook: "/api/channel-setup/tiktok/set-webhook",
    tiktokRemoveWebhook: "/api/channel-setup/tiktok/remove-webhook",
    messengerStatus: "/api/channel-setup/messenger/status",
    messengerSaveToken: "/api/channel-setup/messenger/save-token",
    messengerSetWebhook: "/api/channel-setup/messenger/set-webhook",
    messengerRemoveWebhook: "/api/channel-setup/messenger/remove-webhook",
    wechatStatus: "/api/channel-setup/wechat/status",
    wechatSaveCredentials: "/api/channel-setup/wechat/save-credentials",
    wechatSetWebhook: "/api/channel-setup/wechat/set-webhook",
    wechatRemoveWebhook: "/api/channel-setup/wechat/remove-webhook",
  },
  conversations: {
    list: "/api/conversations/list",
    update: "/api/conversations/update",
  },
  messages: {
    list: "/api/messages/list",
    send: "/api/messages/send",
    sendTemplate: "/api/messages/send-template",
    uploadMedia: "/api/messages/upload-media",
    sendMedia: "/api/messages/send-media",
    translate: "/api/messages/translate",
    /* Gelen medyayı akıtan uç: /api/messages/media/<mesaj id> */
    media: "/api/messages/media",
    metrics: "/api/messages/metrics",
  },
  analytics: {
    dashboard: "/api/analytics/dashboard",
    volume: "/api/analytics/volume",
    automation: "/api/analytics/automation",
    intents: "/api/analytics/intents",
  },
  billing: {
    summary: "/api/billing/summary",
    entitlementsCurrent: "/api/billing/entitlements/current",
    updatePlan: "/api/billing/update-plan",
    checkout: "/api/billing/checkout",
    usageReport: "/api/billing/usage-report",
  },
  payments: {
    checkout: "/api/payments/checkout",
    checkoutResult: "/api/payments/checkout-result",
  },
  subscriptions: {
    plans: "/api/subscriptions/plans",
    current: "/api/subscriptions/current",
    checkExpiry: "/api/subscriptions/check-expiry",
    activate: "/api/subscriptions/activate",
    checkout: "/api/subscriptions/activate",
  },
  affiliates: {
    dashboard: "/api/affiliates/dashboard",
    bankInfo: "/api/affiliates/bank-info",
    payoutRequest: "/api/affiliates/payout-request",
    verify: "/api/affiliates/verify",
    adminList: "/api/affiliates/admin/list",
    adminStats: "/api/affiliates/admin/stats",
    adminPayoutRequests: "/api/affiliates/admin/payout-requests",
    adminCommissions: "/api/affiliates/admin/commissions",
    adminPay: "/api/affiliates/admin/pay",
    adminDetail: "/api/affiliates/admin/detail",
  },
  paddle: {
    clientToken: "/api/paddle/client-token",
    createCheckout: "/api/paddle/create-checkout",
    cancel: "/api/paddle/cancel",
    resume: "/api/paddle/resume",
    subscription: "/api/paddle/subscription",
  },
  superAdmin: {
    dashboardStats: "/api/super-admin/dashboard-stats",
    productEvents: "/api/super-admin/product-events/summary",
    tenantDetail: "/api/super-admin/tenant-detail",
    tenantAction: "/api/super-admin/tenant-action",
    tenantsEnriched: "/api/super-admin/tenants-enriched",
    channelsStatus: "/api/super-admin/channels-status",
    tenantRecentAiMessages: "/api/super-admin/tenant-detail/:id/recent-ai-messages",
    tenantUsageTrend: "/api/super-admin/tenant-detail/:id/usage-trend",
    whatsappAccountsEnriched: "/api/super-admin/whatsapp-accounts-enriched",
    trialEndingSoon: "/api/super-admin/trial-ending-soon",
    topSpenders: "/api/super-admin/top-spenders",
    usersEnriched: "/api/super-admin/users-enriched",
    allTenantMembers: "/api/super-admin/all-tenant-members",
    broadcast: "/api/super-admin/broadcast",
  },
  referrals: {
    summary: "/api/referrals/summary",
    generate: "/api/referrals/generate",
    validate: "/api/referrals/validate",
    applyReward: "/api/referrals/apply-reward",
  },
  demo: {
    message: "/api/demo/message",
  },
  lifecycleEmail: {
    summary: "/api/lifecycle-email/summary",
    savePreferences: "/api/lifecycle-email/preferences",
    sendOnboarding: "/api/lifecycle-email/send-onboarding",
    sendWeeklyReport: "/api/lifecycle-email/send-weekly-report",
    runDue: "/api/lifecycle-email/run-due",
  },
  subscriptionsAdmin: {
    list: "/api/subscriptions/admin/list",
    getById: "/api/subscriptions/admin/getById",
    create: "/api/subscriptions/admin/create",
    update: "/api/subscriptions/admin/update",
    delete: "/api/subscriptions/admin/delete",
  },
  transactionLogsAdmin: {
    list: "/api/subscriptions/admin/transaction-logs/list",
    getById: "/api/subscriptions/admin/transaction-logs/getById",
    create: "/api/subscriptions/admin/transaction-logs/create",
    update: "/api/subscriptions/admin/transaction-logs/update",
    delete: "/api/subscriptions/admin/transaction-logs/delete",
  },
  tenantSettings: {
    list: "/api/tenant-settings/list",
    create: "/api/tenant-settings/create",
    update: "/api/tenant-settings/update",
  },
  appHelp: {
    get: "/api/app-help/get",
    ask: "/api/app-help/ask",
    upsert: "/api/app-help/upsert",
  },
  bossAssistant: {
    settings: "/api/boss-assistant/settings",
    webhookStatus: "/api/boss-assistant/webhook-status",
    test: "/api/boss-assistant/test",
    summary: "/api/boss-assistant/summary",
    dashboard: "/api/boss-assistant/dashboard",
    logs: "/api/boss-assistant/logs",
    logStats: "/api/boss-assistant/log-stats",
    simulateCommand: "/api/boss-assistant/simulate-command",
    simulateCallback: "/api/boss-assistant/simulate-callback",
  },
  webDeveloper: {
    projects: "/api/web-developer/projects",
    project: (id) => `/api/web-developer/project/${id}`,
    generate: "/api/web-developer/generate",
    checkSlug: "/api/web-developer/check-slug",
    save: "/api/web-developer/save",
    publicPage: (slug) => `/api/public/web-landing/${slug}`,
  },
  tenants: {
    list: "/api/tenants/list",
    get: "/api/tenants/get",
  },
  profile: {
    update: "/api/users/profile/update",
    changePassword: "/api/users/profile/change-password",
  },
  waContacts: {
    list: "/api/wa-contacts/list",
    create: "/api/wa-contacts/create",
    update: "/api/wa-contacts/update",
    delete: "/api/wa-contacts/delete",
    export: "/api/wa-contacts/export",
    import: "/api/wa-contacts/import",
    startChat: "/api/wa-contacts/start-chat",
    bulkUpdate: "/api/wa-contacts/bulk-update",
    bulkDelete: "/api/wa-contacts/bulk-delete",
  },
  contactNotes: {
    list: "/api/contact-notes/list",
    create: "/api/contact-notes/create",
    update: "/api/contact-notes/update",
    delete: "/api/contact-notes/delete",
  },
  contactTags: {
    list: "/api/contact-tags/list",
    groups: "/api/contact-tags/groups",
    create: "/api/contact-tags/create",
    delete: "/api/contact-tags/delete",
    deleteByTag: "/api/contact-tags/delete-by-tag",
  },
  contactFields: {
    list: "/api/contact-fields/list",
    keys: "/api/contact-fields/keys",
    create: "/api/contact-fields/create",
    update: "/api/contact-fields/update",
    delete: "/api/contact-fields/delete",
    deleteByKey: "/api/contact-fields/delete-by-key",
  },
  quickReplies: {
    list: "/api/quick-replies/list",
    create: "/api/quick-replies/create",
    delete: "/api/quick-replies/delete",
  },
  appointments: {
    list: "/api/appointments/list",
    create: "/api/appointments/create",
    update: "/api/appointments/update",
    confirm: "/api/appointments/confirm",
    exportIcs: "/api/appointments/ics",
    delete: "/api/appointments/delete",
  },
  patientAdvisor: {
    dashboard: "/api/patient-advisor/dashboard",
    patientsList: "/api/patient-advisor/patients/list",
    patientsCreate: "/api/patient-advisor/patients/create",
    patientsUpdate: "/api/patient-advisor/patients/update",
    notesList: "/api/patient-advisor/notes/list",
    notesCreate: "/api/patient-advisor/notes/create",
    doctorsList: "/api/patient-advisor/doctors/list",
    doctorsCreate: "/api/patient-advisor/doctors/create",
    doctorsUpdate: "/api/patient-advisor/doctors/update",
    branchesList: "/api/patient-advisor/branches/list",
    branchesCreate: "/api/patient-advisor/branches/create",
    branchesUpdate: "/api/patient-advisor/branches/update",
    treatmentPlansList: "/api/patient-advisor/treatment-plans/list",
    treatmentPlansCreate: "/api/patient-advisor/treatment-plans/create",
    treatmentPlansUpdate: "/api/patient-advisor/treatment-plans/update",
    availability: "/api/patient-advisor/availability",
    auditList: "/api/patient-advisor/audit/list",
    vaccinationsList: "/api/patient-advisor/vaccinations/list",
    vaccinationsCreate: "/api/patient-advisor/vaccinations/create",
    vaccinationsUpdate: "/api/patient-advisor/vaccinations/update",
    vaccinationsRemind: "/api/patient-advisor/vaccinations/remind",
    timeline: "/api/patient-advisor/timeline",
    documentsList: "/api/patient-advisor/documents/list",
    documentsUpload: "/api/patient-advisor/documents/upload",
    visitsList: "/api/patient-advisor/visits/list",
    visitsCreate: "/api/patient-advisor/visits/create",
    visitsUpdate: "/api/patient-advisor/visits/update",
    visitsDelete: "/api/patient-advisor/visits/delete",
    packagesList: "/api/patient-advisor/packages/list",
    packagesCreate: "/api/patient-advisor/packages/create",
    packagesUse: "/api/patient-advisor/packages/use",
    packagesUpdate: "/api/patient-advisor/packages/update",
    servicesList: "/api/patient-advisor/services/list",
    servicesUpsert: "/api/patient-advisor/services/upsert",
    servicesDelete: "/api/patient-advisor/services/delete",
    appointmentsRemind: "/api/patient-advisor/appointments/remind",
  },
  quoteRequests: {
    list: "/api/quote-requests/list",
    getById: "/api/quote-requests/getById",
    send: "/api/quote-requests/send",
    updateStatus: "/api/quote-requests/update-status",
    manualCreate: "/api/quote-requests/manual-create",
  },
  orderCatalog: {
    list: "/api/products/list",
    create: "/api/products/create",
    update: "/api/products/update",
    delete: "/api/products/delete",
    bulkUpdate: "/api/products/bulk-update",
    clone: "/api/products/clone",
    export: "/api/products/export",
    import: "/api/products/import",
    priceHistory: "/api/products/price-history",
    uploadImage: "/api/products/upload-image",
  },
  productCatalog: {
    catalogs: "/api/product-catalog-api/catalogs",
  },
  productCategories: {
    list: "/api/product-categories/list",
    create: "/api/product-categories/create",
    update: "/api/product-categories/update",
    delete: "/api/product-categories/delete",
  },
  productTags: {
    list: "/api/product-tags/list",
    create: "/api/product-tags/create",
    update: "/api/product-tags/update",
    delete: "/api/product-tags/delete",
  },
  orders: {
    list: "/api/orders/list",
    getById: "/api/orders/getById",
    update: "/api/orders/update",
    updateStatus: "/api/orders/update-status",
    export: "/api/orders/export",
    create: "/api/orders/create",
  },
  orderSettings: {
    get: "/api/tenant-settings/order-settings/get",
    update: "/api/tenant-settings/order-settings/update",
  },
  aiBots: {
    list: "/api/ai-bots/list",
    sectorPresets: "/api/ai-bots/sector-presets",
    update: "/api/ai-bots/:id/update",
    create: "/api/ai-bots/create",
    delete: "/api/ai-bots/delete",
    applySectorPreset: "/api/ai-bots/apply-sector-preset",
  },
  personas: {
    list: "/api/personas/list",
    create: "/api/personas/create",
    update: "/api/personas/update",
    delete: "/api/personas/delete",
    employeeRegistry: "/api/personas/employee-registry",
    employeePanels: "/api/personas/employee-panels",
    uiSchema: "/api/personas/ui-schema",
    managerCenter: "/api/personas/manager-center",
    managerCenterSettings: "/api/personas/manager-center/settings",
    managerCenterCommand: "/api/personas/manager-center/command",
    managerCenterReport: "/api/personas/manager-center/report",
    managerCenterEmployeeUpdate: (employeeKey) => `/api/personas/manager-center/employee/${employeeKey}/update`,
    managerCenterClaim: (conversationId) => `/api/personas/manager-center/escalation/${conversationId}/claim`,
    managerCenterResolve: (conversationId) => `/api/personas/manager-center/escalation/${conversationId}/resolve`,
    employeePanel: (employeeKey) => `/api/personas/employee-panel/${employeeKey}`,
    employeePanelRuns: (employeeKey) => `/api/personas/employee-panel/${employeeKey}/runs`,
    employeePanelEvents: (employeeKey) => `/api/personas/employee-panel/${employeeKey}/events`,
    employeePanelCommand: (employeeKey) => `/api/personas/employee-panel/${employeeKey}/command`,
    employeeMemoryCreate: (employeeKey) => `/api/personas/employee-panel/${employeeKey}/memory`,
    employeeTaskCreate: (employeeKey) => `/api/personas/employee-panel/${employeeKey}/task`,
    employeeTrainingCreate: (employeeKey) => `/api/personas/employee-panel/${employeeKey}/training`,
    employeeTaskStatus: (taskId) => `/api/personas/employee-task/${taskId}/status`,
  },
  botTemplates: {
    list: "/api/bot-templates/list",
    getById: "/api/bot-templates/getById",
    create: "/api/bot-templates/create",
    update: "/api/bot-templates/update",
    delete: "/api/bot-templates/delete",
  },
  flows: {
    list: "/api/flows/list",
    getById: "/api/flows/getById",
    create: "/api/flows/create",
    update: "/api/flows/update",
    aiGenerate: "/api/flows/ai/generate",
    validate: "/api/flows/validate",
    publish: "/api/flows/publish",
    unpublish: "/api/flows/unpublish",
    duplicate: "/api/flows/duplicate",
    delete: "/api/flows/delete",
    toggle: "/api/flows/toggle",
  },
  knowledgeBase: {
    list: "/api/knowledge-base/list",
    create: "/api/knowledge-base/create",
    upload: "/api/knowledge-base/upload",
    update: "/api/knowledge-base/update",
    delete: "/api/knowledge-base/delete",
    reindex: "/api/knowledge-base/reindex",
    reindexAll: "/api/knowledge-base/reindex-all",
  },
  loyalty: {
    stats: "/api/loyalty/stats",
    transactions: "/api/loyalty/transactions",
  },
  loyaltyQr: {
    settings: "/api/loyalty-qr/settings",
    dashboard: "/api/loyalty-qr/dashboard",
    customers: "/api/loyalty-qr/customers",
    events: "/api/loyalty-qr/events",
    liveQr: "/api/loyalty-qr/live-qr",
    liveQrRefresh: "/api/loyalty-qr/live-qr/refresh",
  },
  surveys: {
    list: "/api/surveys/list",
    stats: "/api/surveys/stats",
    update: "/api/surveys/update",
    casesList: "/api/surveys/cases/list",
    casesUpdate: "/api/surveys/cases/update",
    recoveryList: "/api/surveys/recovery/list",
    recoveryUpdate: "/api/surveys/recovery/update",
    auditList: "/api/surveys/audit/list",
  },
  feedbackCenter: {
    dashboard: "/api/feedback-center/dashboard",
    campaignSave: "/api/feedback-center/campaign/save",
    reviewSave: "/api/feedback-center/review/save",
    complaintCreate: "/api/feedback-center/complaint/create",
    settingsSave: "/api/feedback-center/settings/save",
    command: "/api/feedback-center/command",
  },
  receptionistCenter: {
    dashboard: "/api/receptionist-center/dashboard",
    visitSave: "/api/receptionist-center/visit/save",
    contactSave: "/api/receptionist-center/contact/save",
    unitSave: "/api/receptionist-center/unit/save",
    settingsSave: "/api/receptionist-center/settings/save",
    command: "/api/receptionist-center/command",
  },
  trackingCenter: {
    dashboard: "/api/tracking-center/dashboard",
    shipmentSave: "/api/tracking-center/shipment/save",
    carrierSave: "/api/tracking-center/carrier/save",
    issueSave: "/api/tracking-center/issue/save",
    settingsSave: "/api/tracking-center/settings/save",
    command: "/api/tracking-center/command",
  },
  emailMarketing: {
    accounts: "/api/email-marketing/accounts",
    accountsCreate: "/api/email-marketing/accounts/create",
    accountsUpdate: "/api/email-marketing/accounts/update",
    accountsDelete: "/api/email-marketing/accounts/delete",
    accountsVerify: "/api/email-marketing/accounts/verify",
    accountsToggle: "/api/email-marketing/accounts/toggle",
    accountsTestSend: "/api/email-marketing/accounts/test-send",
    campaigns: "/api/email-marketing/campaigns",
    campaignsCreate: "/api/email-marketing/campaigns/create",
    campaignsUpdate: "/api/email-marketing/campaigns/update",
    campaignsDelete: "/api/email-marketing/campaigns/delete",
    campaignsAiGenerate: "/api/email-marketing/campaigns/ai-generate",
    campaignsTestSend: "/api/email-marketing/campaigns/test-send",
    campaignsLaunch: "/api/email-marketing/campaigns/launch",
    campaignsSchedule: "/api/email-marketing/campaigns/schedule",
    recipientsPreview: "/api/email-marketing/recipients/preview",
  },
  aiEmail: {
    accounts: "/api/ai-email/accounts",
    accountsSave: "/api/ai-email/accounts/save",
    accountsDelete: "/api/ai-email/accounts/delete",
    accountsVerify: "/api/ai-email/accounts/verify",
    sync: "/api/ai-email/sync",
    syncStatus: "/api/ai-email/sync-status",
    messages: "/api/ai-email/messages",
    messageById: "/api/ai-email/messages",
    messageThread: "/api/ai-email/messages",
    messageInsights: "/api/ai-email/messages",
  },
  agentMetrics: {
    performance: "/api/agent-metrics/performance",
    leaderboard: "/api/agent-metrics/leaderboard",
    trends: "/api/agent-metrics/trends",
  },
  notifications: {
    list: "/api/notifications/list",
    unreadCount: "/api/notifications/unread-count",
    markRead: "/api/notifications/mark-read",
    markAllRead: "/api/notifications/mark-all-read",
  },
  systemHealth: {
    summary: "/api/system-health/summary",
  },
  paymentLinks: {
    create: "/api/payment-links/create",
    list: "/api/payment-links/list",
    stats: "/api/payment-links/stats",
    resend: "/api/payment-links/resend",
    cancel: "/api/payment-links/cancel",
  },
  routing: {
    queue: "/api/routing/queue",
    assign: "/api/routing/assign",
    status: "/api/routing/status",
    agents: "/api/routing/agents",
    agentsUpdate: "/api/routing/agents/update",
  },
  agentPreferences: {
    list: "/api/agent-preferences/list",
    create: "/api/agent-preferences/create",
    update: "/api/agent-preferences/update",
    delete: "/api/agent-preferences/delete",
  },
  employeeTasks: {
    list: "/api/employee-tasks/list",
    create: "/api/employee-tasks/create",
    update: "/api/employee-tasks/update",
    complete: "/api/employee-tasks/complete",
    delete: "/api/employee-tasks/delete",
  },
  personalAssistant: {
    list: "/api/personal-assistant/list",
    create: "/api/personal-assistant/create",
    update: "/api/personal-assistant/update",
    complete: "/api/personal-assistant/complete",
    delete: "/api/personal-assistant/delete",
  },
  aiCopilot: {
    command: "/api/ai-copilot/command",
    /* AKIŞ (bulgu 5): adımlar anında görünsün; uç yoksa command'a düşülür. */
    commandStream: "/api/ai-copilot/command/stream",
    briefing: "/api/ai-copilot/briefing",
    proof: "/api/ai-copilot/proof",
    execTool: "/api/ai-copilot/exec-tool",
    tts: "/api/ai-copilot/tts",
    transcribe: "/api/ai-copilot/transcribe",
    setupStatus: "/api/ai-copilot/setup-status",
    setMode: "/api/ai-copilot/set-mode",
    workspaceSummary: "/api/ai-copilot/workspace-summary",
    setSector: "/api/ai-copilot/set-sector",
    suggestReply: "/api/ai-copilot/suggest-reply",
    adjustTone: "/api/ai-copilot/adjust-tone",
    nextAction: "/api/ai-copilot/next-action",
    translate: "/api/ai-copilot/translate",
    suggestTags: "/api/ai-copilot/suggest-tags",
    autoTag: "/api/ai-copilot/auto-tag",
    /* AI KARNESİ (bulgu 15): AI'ın müşteri tarafında ürettiği sonuç. */
    karne: "/api/ai-copilot/karne",
    /* SAHİP KOMUT GEÇMİŞİ (bulgu 41): geçmiş cihazda değil hesapta durur. */
    threads: "/api/ai-copilot/threads",
  },
  projectManager: {
    list: "/api/project-manager/list",
    create: "/api/project-manager/create",
    update: "/api/project-manager/update",
    updateStatus: "/api/project-manager/update-status",
    reorder: "/api/project-manager/reorder",
    stats: "/api/project-manager/stats",
    projects: "/api/project-manager/projects",
    createProject: "/api/project-manager/projects/create",
    updateProject: "/api/project-manager/projects/update",
    archiveProject: "/api/project-manager/projects/archive",
    sprintsList: "/api/project-manager/sprints/list",
    sprintsCreate: "/api/project-manager/sprints/create",
    sprintsUpdate: "/api/project-manager/sprints/update",
    milestonesList: "/api/project-manager/milestones/list",
    milestonesCreate: "/api/project-manager/milestones/create",
    milestonesUpdate: "/api/project-manager/milestones/update",
    templatesList: "/api/project-manager/templates/list",
    templatesCreate: "/api/project-manager/templates/create",
    templatesUpdate: "/api/project-manager/templates/update",
    commentsList: "/api/project-manager/comments/list",
    commentsCreate: "/api/project-manager/comments/create",
    activityList: "/api/project-manager/activity/list",
  },
  reports: {
    summary: "/api/reports/summary",
    exportConversations: "/api/reports/export/conversations",
    exportOrders: "/api/reports/export/orders",
    exportContacts: "/api/reports/export/contacts",
    exportAppointments: "/api/reports/export/appointments",
  },
  branding: {
    get: "/api/branding/get",
    update: "/api/branding/update",
    verifyDomain: "/api/branding/verify-domain",
  },
  webWidget: {
    settings: "/api/web-widget/settings",
    chatLink: "/api/web-widget/chat-link",
    leadNotify: "/api/web-widget/lead-notify",
  },
  whatsappFlows: {
    list: "/api/whatsapp-flows/list",
    templates: "/api/whatsapp-flows/templates",
    create: "/api/whatsapp-flows/create",
    update: "/api/whatsapp-flows/update",
    delete: "/api/whatsapp-flows/delete",
    toggle: "/api/whatsapp-flows/toggle",
    send: "/api/whatsapp-flows/send",
    responses: "/api/whatsapp-flows/responses",
    stats: "/api/whatsapp-flows/stats",
  },
  integrations: {
    dashboard: "/api/integrations/dashboard",
    templates: "/api/integrations/templates",
    list: "/api/integrations/list",
    create: "/api/integrations/create",
    update: "/api/integrations/update",
    delete: "/api/integrations/delete",
    toggle: "/api/integrations/toggle",
    test: "/api/integrations/test",
    settings: "/api/integrations/settings",
    apiKeysCreate: "/api/integrations/api-keys/create",
    apiKeysRotate: "/api/integrations/api-keys/rotate",
    apiKeysDelete: "/api/integrations/api-keys/delete",
    testConnection: "/api/integrations/test-connection",
  },
  scheduledMessages: {
    create: "/api/scheduled-messages/create",
    list: "/api/scheduled-messages/list",
    cancel: "/api/scheduled-messages/cancel",
    stats: "/api/scheduled-messages/stats",
  },
  contactImport: {
    preview: "/api/contact-import/preview",
    import: "/api/contact-import/import",
    export: "/api/contact-import/export",
  },
  auditLogs: {
    list: "/api/audit-logs/list",
  },
  smsMarketing: {
    accounts: "/api/sms-marketing/accounts",
    accountsCreate: "/api/sms-marketing/accounts/create",
    accountsTestSend: "/api/sms-marketing/accounts/test-send",
    accountsVerify: "/api/sms-marketing/accounts/verify",
    accountsToggle: "/api/sms-marketing/accounts/toggle",
    accountsDelete: "/api/sms-marketing/accounts/delete",
    campaigns: "/api/sms-marketing/campaigns",
    campaignsCreate: "/api/sms-marketing/campaigns/create",
    campaignsLaunch: "/api/sms-marketing/campaigns/launch",
    campaignsPause: "/api/sms-marketing/campaigns/pause",
    campaignsStats: "/api/sms-marketing/campaigns/stats",
    campaignsAiGenerate: "/api/sms-marketing/campaigns/ai-generate",
    campaignsSchedule: "/api/sms-marketing/campaigns/schedule",
    overallStats: "/api/sms-marketing/overall-stats",
    creditInfo: "/api/sms-marketing/credit-info",
    recipientsPreview: "/api/sms-marketing/recipients/preview",
    campaignsDelete: "/api/sms-marketing/campaigns/delete",
    tags: "/api/sms-marketing/tags",
    consentSummary: "/api/sms-marketing/consent/summary",
    consentSet: "/api/sms-marketing/consent/set",
  },
  paymentSettings: {
    get: "/api/payment-settings/settings",
    update: "/api/payment-settings/settings/update",
    test: "/api/payment-settings/settings/test",
    setDefault: "/api/payment-settings/settings/set-default",
  },
  callCenter: {
    dashboard: "/api/call-center/dashboard",
    live: "/api/call-center/live",
    logs: "/api/call-center/logs",
    log: "/api/call-center/log",
    stats: "/api/call-center/stats",
    assign: "/api/call-center/log",
    requestCallback: "/api/call-center/log",
    liveTakeoverSession: "/api/call-center/log",
    agentAnswerSession: "/api/call-center/log",
    agentAnswerAccept: "/api/call-center/log",
    note: "/api/call-center/log",
    endCall: "/api/call-center/log",
    resolve: "/api/call-center/log",
  },
  voiceSetup: {
    status: "/api/voice-setup/status",
    enable: "/api/voice-setup/enable",
    settings: "/api/voice-setup/settings",
    test: "/api/voice-setup/test",
    availableNumbers: "/api/voice-setup/available-numbers",
    buyNumber: "/api/voice-setup/buy-number",
    configureWebhook: "/api/voice-setup/configure-webhook",
  },
  botDocuments: {
    list: "/api/bot-documents/list",
    create: "/api/bot-documents/create",
    upload: "/api/bot-documents/upload",
    delete: "/api/bot-documents/delete",
  },
  salesBot: {
    settings: "/api/sales-bot/settings",
    settingsUpdate: "/api/sales-bot/settings/update",
    products: "/api/sales-bot/products",
    stats: "/api/sales-bot/stats",
  },
  supportBot: {
    settings: "/api/support-bot/settings",
    settingsUpdate: "/api/support-bot/settings/update",
    articles: "/api/support-bot/articles",
    stats: "/api/support-bot/stats",
  },
  reservations: {
    list: "/api/reservations/list",
    create: "/api/reservations/create",
    update: "/api/reservations/update",
    updateStatus: "/api/reservations/update-status",
    sendMessage: "/api/reservations/send-message",
    availability: "/api/reservations/availability",
    stats: "/api/reservations/stats",
    report: "/api/reservations/report",
    resourcesList: "/api/reservations/resources/list",
    resourcesUpsert: "/api/reservations/resources/upsert",
    resourcesDelete: "/api/reservations/resources/delete",
  },
  supportTickets: {
    list: "/api/support-tickets/list",
    create: "/api/support-tickets/create",
    update: "/api/support-tickets/update",
    delete: "/api/support-tickets/delete",
    updateStatus: "/api/support-tickets/update-status",
    report: "/api/support-tickets/report",
    stats: "/api/support-tickets/stats",
    assign: "/api/support-tickets/assign",
    resolve: "/api/support-tickets/resolve",
  },
  collections: {
    list: "/api/collections/list",
    create: "/api/collections/create",
    update: "/api/collections/update",
    updateStatus: "/api/collections/update-status",
    remind: "/api/collections/remind",
    report: "/api/collections/report",
    recordPayment: "/api/collections/record-payment",
    setInstallment: "/api/collections/set-installment",
    extendDue: "/api/collections/extend-due",
    escalate: "/api/collections/escalate",
    sendMessage: "/api/collections/send-message",
    stats: "/api/collections/stats",
  },
  accounting: {
    list: "/api/accounting/list",
    create: "/api/accounting/create",
    update: "/api/accounting/update",
    updateStatus: "/api/accounting/update-status",
    stats: "/api/accounting/stats",
    report: "/api/accounting/report",
    taxSummary: "/api/accounting/tax-summary",
    cashFlow: "/api/accounting/cash-flow",
    categories: "/api/accounting/categories",
    categoriesCreate: "/api/accounting/categories/create",
    categoriesDelete: "/api/accounting/categories/delete",
    analyzeUpload: "/api/accounting/analyze-upload",
    recordPayment: "/api/accounting/payment/record",
    paymentHistory: (id) => `/api/accounting/payment/history/${id}`,
    unpaid: "/api/accounting/unpaid",
    overdue: "/api/accounting/overdue",
    sendMessage: "/api/accounting/send-message",
    recurringList: "/api/accounting/recurring/list",
    recurringPause: (id) => `/api/accounting/recurring/pause/${id}`,
    recurringResume: (id) => `/api/accounting/recurring/resume/${id}`,
    recurringCancel: (id) => `/api/accounting/recurring/cancel/${id}`,
    currentAccountsList: "/api/accounting/current-accounts/list",
    currentAccountsCreate: "/api/accounting/current-accounts/create",
    currentAccountsUpdate: "/api/accounting/current-accounts/update",
    currentAccountDetail: (id) => `/api/accounting/current-accounts/${id}/detail`,
    currentAccountStatement: (id) => `/api/accounting/current-accounts/${id}/statement`,
    import: "/api/accounting/import",
    reconciliationsList: "/api/accounting/reconciliations/list",
    reconciliationsCreate: "/api/accounting/reconciliations/create",
    reconciliationsDelete: "/api/accounting/reconciliations/delete",
    export: "/api/accounting/export",
  },
  socialMediaManager: {
    list: "/api/social-media-manager/list",
    stats: "/api/social-media-manager/stats",
    report: "/api/social-media-manager/report",
    calendar: "/api/social-media-manager/calendar",
    templates: "/api/social-media-manager/templates",
    connections: "/api/social-media-manager/connections",
    settings: "/api/social-media-manager/settings",
    generatePreview: "/api/social-media-manager/generate-preview",
    generate: "/api/social-media-manager/generate",
    generateImage: "/api/social-media-manager/generate-image",
    bulkGenerate: "/api/social-media-manager/bulk-generate",
    create: "/api/social-media-manager/create",
    update: "/api/social-media-manager/update",
    delete: "/api/social-media-manager/delete",
    approve: "/api/social-media-manager/approve",
    reject: "/api/social-media-manager/reject",
    schedule: "/api/social-media-manager/schedule",
    publish: "/api/social-media-manager/publish",
    campaignsList: "/api/social-media-manager/campaigns/list",
    campaignsCreate: "/api/social-media-manager/campaigns/create",
    campaignsUpdate: "/api/social-media-manager/campaigns/update",
    seriesList: "/api/social-media-manager/series/list",
    seriesCreate: "/api/social-media-manager/series/create",
    seriesUpdate: "/api/social-media-manager/series/update",
    seriesDelete: "/api/social-media-manager/series/delete",
    mediaLibraryList: "/api/social-media-manager/media-library/list",
    mediaLibraryCreate: "/api/social-media-manager/media-library/create",
    socialConnections: "/api/social-media-manager/social-connections",
    socialConnectionsSave: "/api/social-media-manager/social-connections/save",
    socialConnectionsDelete: "/api/social-media-manager/social-connections/delete",
    socialConnectionsTest: "/api/social-media-manager/social-connections/test",
    oauthStart: "/api/social-media-manager/oauth/start",
  },
  dataAnalyst: {
    list: "/api/data-analyst/list",
    templates: "/api/data-analyst/templates",
    create: "/api/data-analyst/create",
    update: "/api/data-analyst/update",
    delete: "/api/data-analyst/delete",
    updateStatus: "/api/data-analyst/update-status",
    stats: "/api/data-analyst/stats",
    analyzeText: "/api/data-analyst/analyze-text",
    analyzeUpload: "/api/data-analyst/analyze-upload",
    exportPdf: "/api/data-analyst/export-pdf",
    dashboardsList: "/api/data-analyst/dashboards/list",
    dashboardsCreate: "/api/data-analyst/dashboards/create",
    dashboardsUpdate: "/api/data-analyst/dashboards/update",
    dashboardsDelete: "/api/data-analyst/dashboards/delete",
    widgetData: "/api/data-analyst/widgets/data",
    alertsList: "/api/data-analyst/alerts/list",
    alertsCreate: "/api/data-analyst/alerts/create",
    alertsUpdate: "/api/data-analyst/alerts/update",
    alertsToggle: "/api/data-analyst/alerts/toggle",
    alertsDelete: "/api/data-analyst/alerts/delete",
    alertsHistory: "/api/data-analyst/alerts/history",
    targetsList: "/api/data-analyst/targets/list",
    targetsCreate: "/api/data-analyst/targets/create",
    targetsUpdate: "/api/data-analyst/targets/update",
    targetsProgress: "/api/data-analyst/targets",
    compare: "/api/data-analyst/compare",
    forecast: "/api/data-analyst/forecast",
    segment: "/api/data-analyst/segment",
    funnel: "/api/data-analyst/funnel",
    cohort: "/api/data-analyst/cohort",
    correlation: "/api/data-analyst/correlation",
    generateReport: "/api/data-analyst/generate-report",
  },
  legal: {
    list: "/api/legal/list",
    mattersList: "/api/legal/matters/list",
    mattersUpdate: "/api/legal/matters/update",
    approvalsList: "/api/legal/approvals/list",
    approvalsUpdate: "/api/legal/approvals/update",
    deadlinesList: "/api/legal/deadlines/list",
    deadlinesUpdate: "/api/legal/deadlines/update",
    auditList: "/api/legal/audit/list",
    templates: "/api/legal/templates",
    create: "/api/legal/create",
    update: "/api/legal/update",
    updateStatus: "/api/legal/update-status",
    stats: "/api/legal/stats",
    generateDraft: "/api/legal/generate-draft",
    analyzeText: "/api/legal/analyze-text",
    analyzeUpload: "/api/legal/analyze-upload",
    exportPdf: "/api/legal/export-pdf",
    sendMessage: "/api/legal/send-message",
  },
  tenderManager: {
    list: "/api/tender-manager/list",
    stats: "/api/tender-manager/stats",
    sources: "/api/tender-manager/sources",
    discover: "/api/tender-manager/discover",
    create: "/api/tender-manager/create",
    update: "/api/tender-manager/update",
    updateStatus: "/api/tender-manager/update-status",
    generateDocs: "/api/tender-manager/generate-docs",
    exportPdf: "/api/tender-manager/export-pdf",
    evaluateDecision: "/api/tender-manager/evaluate-decision",
    runs: "/api/tender-manager/runs",
    events: "/api/tender-manager/events",
    command: "/api/tender-manager/command",
  },
  salesLeads: {
    list: "/api/sales-leads/list",
    create: "/api/sales-leads/create",
    update: "/api/sales-leads/update",
    delete: "/api/sales-leads/delete",
    updateStatus: "/api/sales-leads/update-status",
    stats: "/api/sales-leads/stats",
    settings: "/api/sales-leads/settings",
    settingsUpdate: "/api/sales-leads/settings/update",
    notesCreate: "/api/sales-leads/notes/create",
    pipelineList: "/api/sales-leads/pipeline/list",
    pipelineUpdate: "/api/sales-leads/pipeline/update",
    followupsList: "/api/sales-leads/followups/list",
    followupsCreate: "/api/sales-leads/followups/create",
    followupsUpdate: "/api/sales-leads/followups/update",
    approvalsList: "/api/sales-leads/approvals/list",
    approvalsUpdate: "/api/sales-leads/approvals/update",
    auditList: "/api/sales-leads/audit/list",
  },
  enrollments: {
    list: "/api/enrollments/list",
    create: "/api/enrollments/create",
    update: "/api/enrollments/update",
    stats: "/api/enrollments/stats",
    evaluate: "/api/enrollments/evaluate",
    runs: "/api/enrollments/runs",
    events: "/api/enrollments/events",
    command: "/api/enrollments/command",
  },
  memberships: {
    list: "/api/memberships/list",
    create: "/api/memberships/create",
    update: "/api/memberships/update",
    updateStatus: "/api/memberships/update-status",
    stats: "/api/memberships/stats",
    evaluate: "/api/memberships/evaluate",
    runs: "/api/memberships/runs",
    events: "/api/memberships/events",
    command: "/api/memberships/command",
    report: "/api/memberships/report",
  },
  leaveRequests: {
    list: "/api/leave-requests/list",
    create: "/api/leave-requests/create",
    update: "/api/leave-requests/update",
    delete: "/api/leave-requests/delete",
    settings: "/api/leave-requests/settings",
    settingsUpdate: "/api/leave-requests/settings/update",
    stats: "/api/leave-requests/stats"
  },
  propertyInquiries: { list: "/api/property-inquiries/list", create: "/api/property-inquiries/create", update: "/api/property-inquiries/update", stats: "/api/property-inquiries/stats",
    listingsList: "/api/property-inquiries/listings/list",
    listingsUpsert: "/api/property-inquiries/listings/upsert",
    listingsDelete: "/api/property-inquiries/listings/delete",
    listingsMatch: "/api/property-inquiries/listings/match",
  },
  realEstate: {
    viewingsList: "/api/real-estate/viewings/list",
    viewingsCreate: "/api/real-estate/viewings/create",
    viewingsDelete: "/api/real-estate/viewings/delete",
    dealsList: "/api/real-estate/deals/list",
    dealsCreate: "/api/real-estate/deals/create",
    dealsUpdate: "/api/real-estate/deals/update",
    dealsDelete: "/api/real-estate/deals/delete",
    authorityList: "/api/real-estate/authority/list",
    authoritySet: "/api/real-estate/authority/set",
    listingsSimple: "/api/real-estate/listings/simple",
  },
  venue: {
    calendar: "/api/venue/calendar",
    eventsList: "/api/venue/events/list",
    eventsDetail: "/api/venue/events/detail",
    eventsCreate: "/api/venue/events/create",
    eventsUpdate: "/api/venue/events/update",
    extrasUpsert: "/api/venue/extras/upsert",
    extrasDelete: "/api/venue/extras/delete",
    paymentsPlan: "/api/venue/payments/plan",
    paymentsRecord: "/api/venue/payments/record",
    paymentsDue: "/api/venue/payments/due",
    report: "/api/venue/report",
    trackSettings: "/api/venue/track/settings",
  },
  daycare: {
    board: "/api/daycare/board",
    childrenList: "/api/daycare/children/list",
    childrenDetail: "/api/daycare/children/detail",
    childrenUpsert: "/api/daycare/children/upsert",
    pickupsUpsert: "/api/daycare/pickups/upsert",
    pickupsRemove: "/api/daycare/pickups/remove",
    logsCheckin: "/api/daycare/logs/checkin",
    logsCheckout: "/api/daycare/logs/checkout",
    logsUpsert: "/api/daycare/logs/upsert",
    logsList: "/api/daycare/logs/list",
    report: "/api/daycare/report",
    trackSettings: "/api/daycare/track/settings",
  },
  optic: {
    board: "/api/optic/board",
    ordersDetail: "/api/optic/orders/detail",
    ordersCreate: "/api/optic/orders/create",
    ordersUpdate: "/api/optic/orders/update",
    examsList: "/api/optic/exams/list",
    examsCreate: "/api/optic/exams/create",
    examsDelete: "/api/optic/exams/delete",
    framesList: "/api/optic/frames/list",
    framesUpsert: "/api/optic/frames/upsert",
    framesDelete: "/api/optic/frames/delete",
    report: "/api/optic/report",
    trackSettings: "/api/optic/track/settings",
  },
  pharmacy: {
    board: "/api/pharmacy/board",
    rxDetail: "/api/pharmacy/rx/detail",
    rxCreate: "/api/pharmacy/rx/create",
    rxUpdate: "/api/pharmacy/rx/update",
    rxDelete: "/api/pharmacy/rx/delete",
    rxItemAdd: "/api/pharmacy/rx/item/add",
    rxItemDelete: "/api/pharmacy/rx/item/delete",
    drugsList: "/api/pharmacy/drugs/list",
    drugsUpsert: "/api/pharmacy/drugs/upsert",
    drugsAdjust: "/api/pharmacy/drugs/adjust",
    drugsDelete: "/api/pharmacy/drugs/delete",
    medicationsList: "/api/pharmacy/medications/list",
    medicationsUpsert: "/api/pharmacy/medications/upsert",
    medicationsDelete: "/api/pharmacy/medications/delete",
    report: "/api/pharmacy/report",
    trackSettings: "/api/pharmacy/track/settings",
  },
  autoService: {
    board: "/api/auto-service/board",
    baysUpsert: "/api/auto-service/bays/upsert",
    baysDelete: "/api/auto-service/bays/delete",
    ordersList: "/api/auto-service/orders/list",
    ordersDetail: "/api/auto-service/orders/detail",
    ordersCheckin: "/api/auto-service/orders/checkin",
    ordersUpdate: "/api/auto-service/orders/update",
    ordersDeliver: "/api/auto-service/orders/deliver",
    linesUpsert: "/api/auto-service/lines/upsert",
    linesApprove: "/api/auto-service/lines/approve",
    linesDelete: "/api/auto-service/lines/delete",
    vehiclesList: "/api/auto-service/vehicles/list",
    vehiclesUpsert: "/api/auto-service/vehicles/upsert",
    vehiclesHistory: "/api/auto-service/vehicles/history",
    partsList: "/api/auto-service/parts/list",
    partsUpsert: "/api/auto-service/parts/upsert",
    partsAdjust: "/api/auto-service/parts/adjust",
    technicians: "/api/auto-service/technicians",
    trackSettings: "/api/auto-service/track/settings",
  },
  ecommerceOps: {
    board: "/api/ecommerce-ops/board",
    orderDetail: "/api/ecommerce-ops/order/detail",
    orderAdvance: "/api/ecommerce-ops/order/advance",
    orderCreate: "/api/ecommerce-ops/order/create",
    picklist: "/api/ecommerce-ops/picklist",
    picklistComplete: "/api/ecommerce-ops/picklist/complete",
    skusList: "/api/ecommerce-ops/skus/list",
    skusUpsert: "/api/ecommerce-ops/skus/upsert",
    skusAdjust: "/api/ecommerce-ops/skus/adjust",
    skusDelete: "/api/ecommerce-ops/skus/delete",
    movements: "/api/ecommerce-ops/movements/list",
    shipments: "/api/ecommerce-ops/shipments",
    returnsList: "/api/ecommerce-ops/returns/list",
    returnsCreate: "/api/ecommerce-ops/returns/create",
    returnsUpdate: "/api/ecommerce-ops/returns/update",
    returnsDelete: "/api/ecommerce-ops/returns/delete",
    profit: "/api/ecommerce-ops/profit",
    trackSettings: "/api/ecommerce-ops/track/settings",
  },
  taxOffice: {
    clientsList: "/api/tax-office/clients/list",
    clientsUpsert: "/api/tax-office/clients/upsert",
    clientsDelete: "/api/tax-office/clients/delete",
    obligationsList: "/api/tax-office/obligations/list",
    openPeriod: "/api/tax-office/obligations/open-period",
    obligationsUpdate: "/api/tax-office/obligations/update",
    documentsList: "/api/tax-office/documents/list",
    documentsCreate: "/api/tax-office/documents/create",
    documentsReceive: "/api/tax-office/documents/receive",
    documentsDelete: "/api/tax-office/documents/delete",
  },
  law: {
    calendar: "/api/law/calendar",
    trackSettings: "/api/law/track/settings",
    hearingsList: "/api/law/hearings/list",
    hearingsUpsert: "/api/law/hearings/upsert",
    hearingsDelete: "/api/law/hearings/delete",
    timeList: "/api/law/time/list",
    timeCreate: "/api/law/time/create",
    timeBill: "/api/law/time/bill",
    timeDelete: "/api/law/time/delete",
    expensesList: "/api/law/expenses/list",
    expensesCreate: "/api/law/expenses/create",
    expensesReimburse: "/api/law/expenses/reimburse",
    expensesDelete: "/api/law/expenses/delete",
  },
  // OTO GALERİ (mig 130) — araç portföyü
  // DÜZENLİ TAHSİLAT (mig 131) — aidat · ücret · taksit · abonelik.
  // Dikkat: `/api/billing` bu ürünün KENDİ SaaS faturasıdır, karıştırma.
  recurring: {
    plans: "/api/recurring/plans",
    plan: "/api/recurring/plan",
    planStatus: "/api/recurring/plan/status",
    run: "/api/recurring/run",
    charges: "/api/recurring/charges",
    charge: "/api/recurring/charge",
    pay: "/api/recurring/charge/pay",
    cancel: "/api/recurring/charge/cancel",
  },
  gallery: {
    stock: "/api/gallery/stock",
    upsert: "/api/gallery/upsert",
    expense: "/api/gallery/expense",
    sell: "/api/gallery/sell",
    remove: "/api/gallery/delete",
  },
  // SERVİS KAYDI (mig 129) — teknik servis · saha hizmeti
  serviceJobs: {
    board: "/api/service-jobs/board",
    create: "/api/service-jobs/create",
    lineAdd: "/api/service-jobs/lines/add",
    lineDecide: "/api/service-jobs/lines/decide",
    status: "/api/service-jobs/status",
    remove: "/api/service-jobs/delete",
    history: "/api/service-jobs/history",
  },
  // TUR & KONTENJAN (mig 128) — seyahat acentesi
  tour: {
    board: "/api/tour/board",
    upsert: "/api/tour/upsert",
    status: "/api/tour/status",
    remove: "/api/tour/delete",
    book: "/api/tour/book",
    bookUpdate: "/api/tour/book/update",
    bookDelete: "/api/tour/book/delete",
  },
  // SEANS PROGRAMI (mig 127) — diyetisyen · fizyoterapi · psikolog
  care: {
    programs: "/api/care/programs",
    upsert: "/api/care/programs/upsert",
    status: "/api/care/programs/status",
    remove: "/api/care/programs/delete",
  },
  // SİGORTA (mig 126) — poliçe & yenileme takvimi
  insurance: {
    renewals: "/api/insurance/renewals",
    list: "/api/insurance/list",
    upsert: "/api/insurance/upsert",
    status: "/api/insurance/status",
    remove: "/api/insurance/delete",
    claims: "/api/insurance/claims",
    claimsUpsert: "/api/insurance/claims/upsert",
    claimsDelete: "/api/insurance/claims/delete",
  },
  // ÜRETİM & TESLİM (mig 125) — pastane · catering · matbaa · fotoğraf
  production: {
    plan: "/api/production/plan",
    list: "/api/production/list",
    create: "/api/production/create",
    update: "/api/production/update",
    remove: "/api/production/delete",
  },
  // CARİ HESAP (mig 124) — 9 sektörün ortak çekirdeği
  account: {
    parties: "/api/account/parties",
    statement: "/api/account/statement",
    entriesCreate: "/api/account/entries/create",
    entriesDelete: "/api/account/entries/delete",
    papersList: "/api/account/papers/list",
    papersCreate: "/api/account/papers/create",
    papersStatus: "/api/account/papers/status",
    papersDelete: "/api/account/papers/delete",
  },
  cafe: {
    shiftsList: "/api/cafe/shifts/list",
    shiftsCreate: "/api/cafe/shifts/create",
    shiftsDelete: "/api/cafe/shifts/delete",
    deliveriesList: "/api/cafe/deliveries/list",
    deliveriesAssign: "/api/cafe/deliveries/assign",
    deliveriesPending: "/api/cafe/deliveries/pending",
    kitchenList: "/api/cafe/kitchen/list",
    kitchenStatus: "/api/cafe/kitchen/status",
    tablesMap: "/api/cafe/tables/map",
    tablesDetail: "/api/cafe/tables/detail",
    tablesMove: "/api/cafe/tables/move",
    menu: "/api/cafe/menu",
    menuManage: "/api/cafe/menu/manage",
    menuCategory: "/api/cafe/menu/category",
    menuCategoryDelete: "/api/cafe/menu/category/delete",
    menuProduct: "/api/cafe/menu/product",
    menuProductDelete: "/api/cafe/menu/product/delete",
    menuOption: "/api/cafe/menu/option",
    menuOptionDelete: "/api/cafe/menu/option/delete",
    menuSettings: "/api/cafe/menu/settings",
    menuImport: "/api/cafe/menu/import",
    callsList: "/api/cafe/calls/list",
    callsDone: "/api/cafe/calls/done",
    itemsTreat: "/api/cafe/items/treat",
    recipesList: "/api/cafe/recipes/list",
    recipesUpsert: "/api/cafe/recipes/upsert",
    recipesDelete: "/api/cafe/recipes/delete",
    wasteList: "/api/cafe/waste/list",
    wasteCreate: "/api/cafe/waste/create",
    wasteDelete: "/api/cafe/waste/delete",
    // Cafe pro (mig 123): hesap bölme · alış · stok sayımı · menü analizi
    checksSplit: "/api/cafe/checks/split",
    checksSeat: "/api/cafe/checks/seat",
    checksClose: "/api/cafe/checks/close",
    shiftsExpected: "/api/cafe/shifts/expected",
    purchasesList: "/api/cafe/purchases/list",
    purchasesCreate: "/api/cafe/purchases/create",
    purchasesDelete: "/api/cafe/purchases/delete",
    stockCountList: "/api/cafe/stock-count/list",
    stockCountCreate: "/api/cafe/stock-count/create",
    stockCountDelete: "/api/cafe/stock-count/delete",
    reportMenu: "/api/cafe/report/menu",
    reportTraffic: "/api/cafe/report/traffic",
    menuTemplates: "/api/cafe/menu/templates",
    menuSeed: "/api/cafe/menu/seed",
    qrTables: "/api/cafe/qr/tables",
    itemsQty: "/api/cafe/items/qty",
    waitersReport: "/api/cafe/waiters/report",
  },
  hotel: {
    board: "/api/hotel/board",
    trackSettings: "/api/hotel/track/settings",
    roomsList: "/api/hotel/rooms/list",
    roomsStatus: "/api/hotel/rooms/status",
    folioList: "/api/hotel/folio/list",
    folioCreate: "/api/hotel/folio/create",
    folioDelete: "/api/hotel/folio/delete",
    folioClose: "/api/hotel/folio/close",
    ratesList: "/api/hotel/rates/list",
    ratesUpsert: "/api/hotel/rates/upsert",
    ratesDelete: "/api/hotel/rates/delete",
  },
  education: {
    trackSettings: "/api/education/track/settings",
    attendanceList: "/api/education/attendance/list",
    attendanceCreate: "/api/education/attendance/create",
    attendanceDelete: "/api/education/attendance/delete",
    attendanceRisky: "/api/education/attendance/risky",
    examsList: "/api/education/exams/list",
    examsCreate: "/api/education/exams/create",
    examsDelete: "/api/education/exams/delete",
    guardiansList: "/api/education/guardians/list",
    guardiansUpsert: "/api/education/guardians/upsert",
    guardiansDelete: "/api/education/guardians/delete",
  },
  gym: {
    classesList: "/api/gym/classes/list",
    classesCreate: "/api/gym/classes/create",
    classesUpdate: "/api/gym/classes/update",
    classesDelete: "/api/gym/classes/delete",
    bookingsList: "/api/gym/bookings/list",
    bookingsCreate: "/api/gym/bookings/create",
    bookingsUpdate: "/api/gym/bookings/update",
    bookingsDelete: "/api/gym/bookings/delete",
    checkinsList: "/api/gym/checkins/list",
    checkinsCreate: "/api/gym/checkins/create",
    checkinsDelete: "/api/gym/checkins/delete",
    checkinsInactive: "/api/gym/checkins/inactive",
    trackSettings: "/api/gym/track/settings",
  },
  aesthetic: {
    trackSettings: "/api/aesthetic/track/settings",
    injectionsList: "/api/aesthetic/injections/list",
    injectionsCreate: "/api/aesthetic/injections/create",
    injectionsDelete: "/api/aesthetic/injections/delete",
    devicesList: "/api/aesthetic/devices/list",
    devicesCreate: "/api/aesthetic/devices/create",
    devicesDelete: "/api/aesthetic/devices/delete",
    followupsList: "/api/aesthetic/followups/list",
    followupsUpsert: "/api/aesthetic/followups/upsert",
    followupsDelete: "/api/aesthetic/followups/delete",
  },
  dental: {
    chartList: "/api/dental/chart/list",
    chartCreate: "/api/dental/chart/create",
    chartDelete: "/api/dental/chart/delete",
    anamnesisList: "/api/dental/anamnesis/list",
    anamnesisUpsert: "/api/dental/anamnesis/upsert",
    anamnesisDelete: "/api/dental/anamnesis/delete",
    labList: "/api/dental/lab/list",
    labUpsert: "/api/dental/lab/upsert",
    labDelete: "/api/dental/lab/delete",
  },
  vet: {
    prescriptionsList: "/api/vet/prescriptions/list",
    prescriptionsUpsert: "/api/vet/prescriptions/upsert",
    prescriptionsDelete: "/api/vet/prescriptions/delete",
    labsList: "/api/vet/labs/list",
    labsCreate: "/api/vet/labs/create",
    labsDelete: "/api/vet/labs/delete",
    boardingList: "/api/vet/boarding/list",
    boardingCheckin: "/api/vet/boarding/checkin",
    boardingCheckout: "/api/vet/boarding/checkout",
    boardingDelete: "/api/vet/boarding/delete",
  },
  salon: {
    formulasList: "/api/salon/formulas/list",
    formulasCreate: "/api/salon/formulas/create",
    formulasDelete: "/api/salon/formulas/delete",
    patchList: "/api/salon/patch-tests/list",
    patchUpsert: "/api/salon/patch-tests/upsert",
    patchDelete: "/api/salon/patch-tests/delete",
    commissionList: "/api/salon/commission/list",
    commissionUpsert: "/api/salon/commission/upsert",
    waitlistList: "/api/salon/waitlist/list",
    waitlistUpsert: "/api/salon/waitlist/upsert",
    waitlistDelete: "/api/salon/waitlist/delete",
    vouchersList: "/api/salon/vouchers/list",
    vouchersCreate: "/api/salon/vouchers/create",
    vouchersRedeem: "/api/salon/vouchers/redeem",
    vouchersCancel: "/api/salon/vouchers/cancel",
    photosList: "/api/salon/photos/list",
    photosUpload: "/api/salon/photos/upload",
    photosDelete: "/api/salon/photos/delete",
    consentTemplates: "/api/salon/consent/templates",
    consentTemplateUpsert: "/api/salon/consent/templates/upsert",
    consentTemplateDelete: "/api/salon/consent/templates/delete",
    consentList: "/api/salon/consent/list",
    consentCreate: "/api/salon/consent/create",
    consentDelete: "/api/salon/consent/delete",
  },
  construction: {
    sitesList: "/api/construction/sites/list",
    sitesUpsert: "/api/construction/sites/upsert",
    sitesDelete: "/api/construction/sites/delete",
    logsList: "/api/construction/logs/list",
    logsCreate: "/api/construction/logs/create",
    logsDelete: "/api/construction/logs/delete",
    attendanceList: "/api/construction/attendance/list",
    attendanceCreate: "/api/construction/attendance/create",
    attendanceDelete: "/api/construction/attendance/delete",
    paymentsList: "/api/construction/payments/list",
    paymentsUpsert: "/api/construction/payments/upsert",
    paymentsDelete: "/api/construction/payments/delete",
  },
  onboardingProgress: {
    list: "/api/onboarding-progress/list",
    create: "/api/onboarding-progress/create",
    update: "/api/onboarding-progress/update",
    stats: "/api/onboarding-progress/stats",
    evaluate: "/api/onboarding-progress/evaluate",
    runs: "/api/onboarding-progress/runs",
    events: "/api/onboarding-progress/events",
    command: "/api/onboarding-progress/command",
  },
  secretary: {
    list: "/api/secretary/list",
    create: "/api/secretary/create",
    update: "/api/secretary/update",
    updateStatus: "/api/secretary/update-status",
    stats: "/api/secretary/stats",
    evaluate: "/api/secretary/evaluate",
    runs: "/api/secretary/runs",
    events: "/api/secretary/events",
    command: "/api/secretary/command",
  },
  marketingContacts: {
    list: "/api/marketing-contacts/list",
    create: "/api/marketing-contacts/create",
    update: "/api/marketing-contacts/update",
    delete: "/api/marketing-contacts/delete",
    bulkDelete: "/api/marketing-contacts/bulk-delete",
    import: "/api/marketing-contacts/import",
    export: "/api/marketing-contacts/export",
    stats: "/api/marketing-contacts/stats",
    tags: "/api/marketing-contacts/tags",
  },
  emailPackages: {
    packages: "/api/email-packages/packages",
    balance: "/api/email-packages/balance",
    history: "/api/email-packages/history",
    purchase: "/api/email-packages/purchase",
    fromInfo: "/api/email-packages/from-info",
    campaigns: "/api/email-packages/campaigns",
    campaignsCreate: "/api/email-packages/campaigns/create",
    campaignsLaunch: "/api/email-packages/campaigns/launch",
    stats: "/api/email-packages/stats",
  },
  smsPackages: {
    packages: "/api/sms-packages/packages",
    balance: "/api/sms-packages/balance",
    history: "/api/sms-packages/history",
    purchase: "/api/sms-packages/purchase",
    senderId: "/api/sms-packages/sender-id",
    adminCreate: "/api/sms-packages/admin/packages/create",
    adminUpdate: "/api/sms-packages/admin/packages/update",
    adminDelete: "/api/sms-packages/admin/packages/delete",
  },
  bossAssistant: {
    settings: "/api/boss-assistant/settings",
    settingsUpdate: "/api/boss-assistant/settings/update",
    saveToken: "/api/boss-assistant/save-token",
    webhookStatus: "/api/boss-assistant/webhook-status",
    linkTelegram: "/api/boss-assistant/link-telegram",
    test: "/api/boss-assistant/test",
    summary: "/api/boss-assistant/summary",
    dashboard: "/api/boss-assistant/dashboard",
    logs: "/api/boss-assistant/logs",
    logStats: "/api/boss-assistant/log-stats",
  },
  spider: {
    proxy: "/api/spider/proxy",
    autoExtract: "/api/spider/auto-extract",
    scrape: "/api/spider/scrape",
    jobs: "/api/spider/jobs",
    export: "/api/spider/export",
  },
  googleAds: {
    authLogin: "/api/google-ads/auth/login",
    selectCustomer: "/api/google-ads/auth/select-customer",
    accessibleCustomers: "/api/google-ads/auth/accessible-customers",
    account: "/api/google-ads/account",
    campaigns: "/api/google-ads/campaigns",
    createCampaign: "/api/google-ads/campaigns/create",
    pause: (id) => `/api/google-ads/campaigns/${id}/pause`,
    resume: (id) => `/api/google-ads/campaigns/${id}/resume`,
    remove: (id) => `/api/google-ads/campaigns/${id}`,
    campaignStats: (id) => `/api/google-ads/campaigns/${id}/stats`,
    stats: "/api/google-ads/stats",
    aiSuggest: "/api/google-ads/ai/suggest",
    // FAZ 2 — detail page endpoints
    campaignDetails: (id) => `/api/google-ads/campaigns/${id}/details`,
    campaignKeywords: (id) => `/api/google-ads/campaigns/${id}/keywords`,
    campaignSearchTerms: (id) => `/api/google-ads/campaigns/${id}/search-terms`,
    addKeywords: (id) => `/api/google-ads/campaigns/${id}/keywords`,
    addNegativeKeywords: (id) => `/api/google-ads/campaigns/${id}/negative-keywords`,
    pauseKeyword: (id) => `/api/google-ads/campaigns/${id}/keywords/pause`,
    // FAZ 3 — AI Optimizer
    optimizeSuggest: "/api/google-ads/optimize/suggest",
    optimizeApply: "/api/google-ads/optimize/apply",
    // FAZ 4
    updateBudget: (id) => `/api/google-ads/campaigns/${id}/budget`,
    cloneCampaign: (id) => `/api/google-ads/campaigns/${id}/clone`,
  },
  aiVideo: {
    avatars: "/api/ai-video/avatars",
    photoAvatars: "/api/ai-video/photo-avatars",
    photoAvatarsUpload: "/api/ai-video/photo-avatars/upload",
    photoAvatarsGenerate: "/api/ai-video/photo-avatars/generate",
    photoAvatarDelete: (id) => `/api/ai-video/photo-avatars/${id}`,
    voices: "/api/ai-video/voices",
    estimate: "/api/ai-video/estimate",
    scriptSuggest: "/api/ai-video/script/suggest",
    generate: "/api/ai-video/generate",
    generateAudio: "/api/ai-video/generate-audio",
    ttsPreview: "/api/ai-video/tts-preview",
    generateImage: "/api/ai-video/generate-image",
    generateShortVideo: "/api/ai-video/generate-short-video",
    musicPresets: "/api/ai-video/music-presets",
    stockMedia: "/api/ai-video/stock-media",
    uploadMedia: "/api/ai-video/upload-media",
    assets: "/api/ai-video/assets",
    deleteAsset: (id) => `/api/ai-video/assets/${id}`,
    jobs: "/api/ai-video/jobs",
    job: (id) => `/api/ai-video/jobs/${id}`,
    refresh: (id) => `/api/ai-video/jobs/${id}/refresh`,
    translate: (id) => `/api/ai-video/jobs/${id}/translate`,
    remove: (id) => `/api/ai-video/jobs/${id}`,
  },
  /* Ayarlar > Destek formu — ChatPilots destek ekibine gider.
     supportTickets ile karistirilmasin: o, musterinin kendi musterileri icin. */
  support: {
    contact: "/api/support/contact",
  },
};

export default API_ENDPOINTS;
